export default __webpack_public_path__ + "static/python-course-price-e372d6836cb810604734da7faf56f1ee.webp";